// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Belt_SetInt from "rescript/lib/es6/belt_SetInt.js";
import * as UserContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/UserContext.res.mjs";
import * as LocalStorage$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/LocalStorage.res.mjs";

var key = "wfBadges";

function toString(dict) {
  return Belt_Option.getWithDefault(JSON.stringify(dict), "{}");
}

function fromString(data) {
  return Belt_Option.map(data, (function (d) {
                return JSON.parse(d);
              }));
}

var LocalStorageConfig = {
  key: key,
  toString: toString,
  fromString: fromString
};

var BadgesStorage = LocalStorage$LiteracyplanetClientFlags.Make({
      key: key,
      fromString: fromString,
      toString: toString
    });

function useWithNamespace(userId) {
  return Curry._1(BadgesStorage.useLocalStorageWithNamespace, userId);
}

function use(journeyGate, units) {
  var user = UserContext$LiteracyplanetClientFlags.use();
  var match = Curry._1(BadgesStorage.useLocalStorageWithNamespace, user.userId);
  var setBadgesSeen = match[1];
  var match$1 = React.useState(function (param) {
        
      });
  var setClaimedBadge = match$1[1];
  var badgesDict = Belt_Option.getWithDefault(match[0], {});
  var journeyBadges = Belt_SetInt.fromArray(Belt_Option.getWithDefault(Js_dict.get(badgesDict, journeyGate), []));
  var hasUnitBadge = function (activities) {
    return activities.every(function (a) {
                return Belt_Option.mapWithDefault(a.result.bestResponsesScore, false, (function (score) {
                              return score >= 80;
                            }));
              });
  };
  var availableUnitBadges = Belt_Array.reduceWithIndex(units, undefined, (function (bdgs, param, idx) {
          if (hasUnitBadge(param.activities)) {
            return Belt_SetInt.add(bdgs, idx + 1 | 0);
          } else {
            return bdgs;
          }
        }));
  React.useEffect((function (param) {
          var badgeToClaim = Belt_Option.flatMap(Belt_SetInt.maximum(availableUnitBadges), (function (b) {
                  if (Belt_SetInt.has(journeyBadges, b)) {
                    return ;
                  } else {
                    return b;
                  }
                }));
          Curry._1(setClaimedBadge, (function (param) {
                  return badgeToClaim;
                }));
          badgesDict[journeyGate] = Belt_SetInt.toArray(availableUnitBadges);
          Curry._1(setBadgesSeen, badgesDict);
        }), [journeyGate]);
  return [
          availableUnitBadges,
          match$1[0]
        ];
}

export {
  LocalStorageConfig ,
  BadgesStorage ,
  useWithNamespace ,
  use ,
}
/* BadgesStorage Not a pure module */
